module.exports = __webpack_public_path__ + "static/media/webdevelopment.1b48b895.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/webdevelopment.jpg
// module id = 206
// module chunks = 0